'use strict';

SwaggerEditor.config(function($provide) {
  $provide.constant('defaults', window.SwaggerEditor.$defaults);
});



/*****************
 ** WEBPACK FOOTER
 ** ./scripts/enums/defaults.js
 ** module id = 426
 ** module chunks = 0
 **/